export default __webpack_public_path__ + "static/media/colors-1024w.c7430fe7.png";